export const SET_USAGE_HISTORY_SUMMARY = 'SET_USAGE_HISTORY_SUMMARY'
export const RESET_USAGE_HISTORY_SUMMARY = 'RESET_USAGE_HISTORY_SUMMARY'